export const toNodeId = () => `studio-${window.crypto.randomUUID()}`;
